export default {
  messages: {
    required: 'This field is required.',
    email: 'The Email is in an invalid format',
    alpha: 'Please use letters only.',
    name: 'Please use letters only.',
    url: 'The URL is not valid',
    phone: 'Please enter a 10-digit number.',
    image: 'Please upload file in PNG, GIF, or JPG format',
    size: 'Uploaded file cannot be more than 2MB',
    without_spaces: 'Password can\'t contain spaces ',
    card_expiration: 'Expiration date is invalid',
    card_number: 'Card number is invalid',
    numeric: 'Please use digits only',
    password: 'Invalid character',
  },
};
